export default {
    download: 'Pobierz'
}
